import ComboModule from '@/modules/product/combo';
import { createFileRoute } from '@tanstack/react-router';
import z from 'zod';

const comboSearchSchema = z.object({
  page: z.coerce.number().optional(),
  perPage: z.coerce.number().optional(),
  searchParam: z
    .enum(['comboId', 'categoryName', 'brandName', 'comboName'])
    .optional(),
  searchValue: z.string().optional(),
});

export const Route = createFileRoute('/dashboard/product/combo/')({
  validateSearch: comboSearchSchema,
  component: ComboModule,
});
